import {
    Route,
    Switch,
    useRouteMatch
} from 'react-router-dom';
import { CommonLayoutForInvestor } from '../commonComponents';
import Cart from '.';
import VerifyCartOtp from './VerifyCartOtp';
import PaymentScreen from '../../lib/paymentScreen';

function Routes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route
                exact
                path={`${path}`}
                render={() => <Cart />}
            />
            <Route
                exact
                path={`${path}/verify-otp`}
                render={() => <VerifyCartOtp />}
            />
            <Route
                exact
                path={`${path}/payment`}
                render={() => <PaymentScreen />}
            />
        </Switch>
    );
}

export default function CartRouter(): JSX.Element {

    return (
        <CommonLayoutForInvestor>
            <Routes />
        </CommonLayoutForInvestor>
    )
}
